module.exports = __webpack_public_path__ + "media/images/emoticons/bicycle-9fd6c85e3ea81c5d409ae03dd90200df.gif";